<template>
	<div class="small-12 flex page propertyUnits popertyListingsLayout animated fadeIn" v-if="loaded && user">
		<primary-nav :user="user"/>
		<div class="small-12 large-10 pageContentWrap">
			<div class="small-12 pageContent">
				<div class="small-12 centerColumn">
					<div class="small-12 details">
						<div class="small-12 pageNav flex vertical-align border-bottom" v-if="property">
							<property-nav :property="property"/>
							<site-nav :user="user"/>
						</div>
						<div class="small-12 mainContent">
							<units-listing :property="property" :company="company"/>
						</div>
					</div>
				</div>
			</div>
		</div>
		<new-version-modal :show_modal="!user.attributes.has_latest_version" v-show="!user.attributes.has_latest_version"/>
	</div>
	<loading-spinner :loaded="loaded" v-else/>
</template>

<script>

	// Import the components
	import LoadingSpinner from '@/components/framework/helpers/LoadingSpinner.vue'
	import PrimaryNav from '@/components/framework/nav/PrimaryNav.vue'
	import PropertyNav from '@/components/property/shared/PropertyNav.vue'
	import UnitsListing from '@/components/property/units/UnitsListing.vue'
	import SiteNav from '@/components/framework/nav/SiteNav.vue'
	import NewVersionModal from '@/components/framework/modals/NewVersionModal.vue'

	// Import the events
	import { GetAppVersion } from '@/events/app/GetAppVersion'
	import { BindUser } from '@/events/users/BindUser'
	import { GetProperty } from '@/events/property/GetProperty'
	import { GetCompany } from '@/events/company/GetCompany'
	
	export default {

		/*
		** Set the component name
		*/

		name: 'Index',

		/*
		**  Register the components
		*/

		components: {

			LoadingSpinner,
			PrimaryNav,
			PropertyNav,
			UnitsListing,
			SiteNav,
			NewVersionModal

		},

		/*
		**  Register the mixins
		*/

		mixins: [

			GetAppVersion,
			BindUser,
			GetProperty,
			GetCompany

		],

		/*
		**  Set the props
		*/

		props: {

			//

		},

		/*
		**  Set up the data
		*/

		data: () => ({

			loaded: false

		}),

		/*
		**  Watch em'
		*/

		watch: {

			user: {

				immediate: true, // Load on created
				handler(user) {

					/*
                    ** Get the property
                    ** @event: Events/Properties/GetProperty
                    */

				   	if (user) this.getPropertyHandler();

				}

			},

			property: {

				immediate: true, // Load on created
				handler(property) {

                    /*
                    ** Get the company
                    ** @method: Events/Company/GetCompany
                    */

				   	if (property && this.user.id == property.relationships.user) {
					
						if (this.user.relationships.company) this.getCompanyHandler();
						if (!this.user.relationships.company) this.loaded = true;
						   
					} else if (property && this.user.id !== property.relationships.user) {

						/*
						** Notify the user
						** @service: @SweetAlert2
						*/

						this.$swal('Uh Oh!', 'Looks like you don\'t have the necessary permissions to view this property.', 'error');
 
						/*
						** Redirect user to properties dashboard page
						** @service: @Vue
						*/

						this.$router.push({ name: 'PropertiesDashboard' });

					}

                }

            },

			company: {

				immediate: true, // Load on created
				handler(company) {

                    /*
                    ** Set the prop
                    ** @prop: @here
                    */

					if (company) this.loaded = true;

                }

            },

		},

		/*
		**  Do this first
		*/

		created() {

			/*
			**  Get the user
			**  @event: Events/Users/BindUser
			*/

			this.bindUserHandler();

		},

        /*
		**  Set up the methods
		*/

		methods: {

			//

		},

		/*
		**  Set the computed props
		*/

		computed: {

			//

		}

	}

</script>